import React, { useEffect } from 'react'
import styles from '../modal.module.css'

import {
  mostRecentStatusOptions,
  mostRecentStatusValueMap
} from '../../MostRecentStatus'
// Assume that `mostRecentStatusOptions` is an array of status options like ['For Sale', 'Rental', ...]
import Tooltip from '@mui/material/Tooltip'
import infoIcon from './images/circle-info-regular-full.svg'

function MostRecentStatus ({ localMostRecentStatus, setLocalMostRecentStatus }) {
  const handleStatusClick = statusLabel => {
    const statusValue = mostRecentStatusValueMap[statusLabel] || statusLabel

    let newStatuses
    if (localMostRecentStatus.includes(statusValue)) {
      // Remove the status if it's already selected
      newStatuses = localMostRecentStatus.filter(s => s !== statusValue)
    } else {
      // Add the status if it's not already selected
      newStatuses = [...localMostRecentStatus, statusValue]
    }

    // If no statuses are selected, default back to ["Any"]
    if (newStatuses.length === 0) {
      newStatuses = ['Any']
    }

    setLocalMostRecentStatus(newStatuses)
  }

  useEffect(() => {
    // Remove "Any" from the array if it exists
    if (localMostRecentStatus.includes('Any')) {
      const filteredTypes = localMostRecentStatus.filter(type => type !== 'Any')
      setLocalMostRecentStatus(filteredTypes)
    }
  }, [localMostRecentStatus, setLocalMostRecentStatus])

  return (
    <div>
      <section className={styles.mostRecentStatusSection}>
        <div className={styles.sectionTitleWithIcon}>
          <h1 className={styles.sectionHeading}>Most recent status</h1>
          <Tooltip
            title="Filter by the property’s most recent status."
            arrow
            placement='top'
            slotProps={{
              popper: {
                sx: {
                  [`& .MuiTooltip-tooltip`]: {
                    maxWidth: 500,
                    fontSize: '13px',
                    padding: '8px'
                  }
                }
              }
            }}
          >
            <img
              src={infoIcon}
              alt='Most recent status info'
              width={14}
              height={14}
              className={styles.infoIcon}
              tabIndex={0}
              style={{marginTop:'1px'}}
            />
          </Tooltip>
        </div>

        <h2 className={styles.mostRecentStatusLabelTitle}>
          Select multiple options if needed.
        </h2>
        <div className={styles.mostRecentStatusButtons}>
          {mostRecentStatusOptions
            .filter(option => option !== 'Any') // This will exclude the "Any" option
            .map(statusLabel => (
              <button
                key={statusLabel}
                id={statusLabel}
                name={statusLabel}
                className={`${styles.mostRecentStatusButton} ${
                  localMostRecentStatus.includes(
                    mostRecentStatusValueMap[statusLabel] || statusLabel
                  )
                    ? styles.active
                    : ''
                }`}
                onClick={() => handleStatusClick(statusLabel)}
              >
                {statusLabel}
              </button>
            ))}
        </div>
      </section>
      {/* <hr className={styles.hrStyle} /> */}
    </div>
  )
}

export default MostRecentStatus
